import { render, staticRenderFns } from "./FieldPrice.vue?vue&type=template&id=788f1849"
import script from "./FieldPrice.vue?vue&type=script&lang=js"
export * from "./FieldPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports